<template>
  <sdf-icon v-bind="$props" :class="[$attrs.class, 'hydrated']"></sdf-icon>
</template>

<script setup lang="ts">
import type { JSX } from '@waypoint/web-components';

defineOptions({
  name: 'SdfIcon',
});

defineProps<Partial<JSX.SdfIcon>>();
</script>
